import { getMatchesMatchIds } from './../reducers/matches';
import { Middleware } from "redux";
import { customInternalData, switchCompetitor, switchEvents, sendCurrentPhaseData } from "../actions/customerMethods";
import { PHASE_PRE_MATCH, PHASE_POST_POINT, PHASE_BETSTOP, PHASE_RALLY, PHASE_POST_MATCH } from "../api/phases";
import { FETCH_TIMINGS_SUCCEEDED, PROPAGATE_COUNTDOWN_BY_CHANNEL, CHANGE_CHANNEL, CUSTOMER_METHODS_OPEN_COMPETITOR_STATS, PREPARE_CURRENT_DATA, INIT_APPLICATION_FINISHED } from "../actions/actionTypes";
import { getActiveMatchId, getPhaseIdByMatchId, getChannelIdByMatchId, getNextBetstopByChannelId, getMatchIdsForChannelsWithNewPhases, getMatchIdByChannelId } from "../reducers/timings";
import { getActiveChannelId, getInitApplicationState } from "../reducers/gui";
import { IState } from "../store/state";
import { getLanguage, getS5Alias } from "../reducers/config";
import { getSeasonId } from "../reducers/matches";
import { getStatisticCenterBaseUrl } from "../reducers/bookmakerOptions";
import { openStatisticCenter } from "../utils/statisticCenter";
import { getStatisticCenterTeamsURL } from "../api/assetUrls";

const customerIntegrationMiddleware: Middleware = store => next => action => {
    const result = next(action);
    const state = store.getState() as any as IState;
    const activeMatchId = getActiveMatchId(state);
    switch (action.type) {
        case CHANGE_CHANNEL:

            // switchCompetitor and switchEvents of the new channels match for every channelchange
            const newActiceChannelid : number = (action as any).id
            const newActiveChannelMatchid : number = getMatchIdByChannelId(state, newActiceChannelid)
            const nextBetstop = getNextBetstopByChannelId(state, newActiceChannelid);
            store.dispatch(switchCompetitor({
                event_start: nextBetstop,
                event_ids: [newActiveChannelMatchid],
                unified_event_ids: ['vti:match:' + newActiveChannelMatchid],
                active_match_id: 'vti:match:' + newActiveChannelMatchid,
            }));
            store.dispatch(switchEvents({
                event_start: nextBetstop,
                event_ids: [newActiveChannelMatchid],
                unified_event_ids: ['vti:match:' + newActiveChannelMatchid]
            }));

            break;
        case FETCH_TIMINGS_SUCCEEDED:
            const isApplicationReady = getInitApplicationState(state);
            const changeChannelMatchIds : number[] = getMatchIdsForChannelsWithNewPhases(state);
            for( let matchId of changeChannelMatchIds ) {
                const phaseId = getPhaseIdByMatchId(state,matchId);
                const channelId = getChannelIdByMatchId(state,matchId);
                const nextBetstop = getNextBetstopByChannelId(state,channelId);
                if(!isApplicationReady || phaseId === PHASE_PRE_MATCH || phaseId === PHASE_POST_POINT) {
                    store.dispatch(switchCompetitor({
                        event_start: nextBetstop,
                        event_ids: [matchId],
                        unified_event_ids: ['vti:match:' + matchId],
                        active_match_id: 'vti:match:' + activeMatchId,
                    }));
                }
                if(!isApplicationReady || phaseId === PHASE_PRE_MATCH) {
                    if (matchId === activeMatchId) {
                        store.dispatch(switchEvents({
                            event_start: nextBetstop,
                            event_ids: [activeMatchId],
                            unified_event_ids: ['vti:match:' + matchId]
                        }));
                    }
                }
                if(!isApplicationReady || (phaseId === PHASE_BETSTOP && matchId==activeMatchId)) {
                    store.dispatch(switchCompetitor({
                        event_start: nextBetstop,
                        event_ids: [matchId],
                        unified_event_ids: ['vti:match:' + matchId],
                        active_match_id: 'vti:match:' + activeMatchId,
                    }));
                }
            }
            break;
        case INIT_APPLICATION_FINISHED :
            const matches : number[] = getMatchesMatchIds(state); 
            for( let matchId of matches ) {
                const channelId = getChannelIdByMatchId(state,matchId);
                const nextBetstop = getNextBetstopByChannelId(state,channelId);
                const activeMatchId = getActiveMatchId(state);
                store.dispatch(switchCompetitor({
                    event_start: nextBetstop,
                    event_ids: [matchId],
                    unified_event_ids: ['vti:match:' + matchId],
                    active_match_id: 'vti:match:' + activeMatchId,
                }));
            }
            // listen to vti-request-mobile-header 
            window.addEventListener("message", function(event:any) {
                if(event.data && typeof event.data == 'string') {
                    const data = JSON.parse(event.data);
                    if(data.messageType && data.messageType==='vti-request-mobile-header') {
                        const wrapper = document.getElementsByClassName('defaultGuiWrapper');
                        if(wrapper) {
                            // set classname to select mobile styling
                            if(!wrapper[0].classList.contains('mobile')) {
                                wrapper[0].classList.add('mobile')
                            }
                            // send vti-response-mobile-header 
                            const header = document.getElementsByClassName('textWrapperAndCountdown');
                            if(parent && header) {
                                parent.postMessage(JSON.stringify({
                                    messageType: 'vti-response-mobile-header',
                                    header: header[0].innerHTML
                                }), '*');
                            }
                        }
                    }
                }
            }.bind(this), false);
            break;
        case PROPAGATE_COUNTDOWN_BY_CHANNEL:
            const data = (action as any).data;
            propagateCountdownByChannel(store,data.countdown,data.channelId);
            break;
        case CUSTOMER_METHODS_OPEN_COMPETITOR_STATS:
            const teamIds = getIdOfMessage((action as any).data);
            openStatisticCenter(getStatisticCenterTeamsURL(
                getStatisticCenterBaseUrl(state),
                getSeasonId(state),
                teamIds[0],
                teamIds[1],
                getLanguage(state),
                getS5Alias(state),
            ));
            break;
        case PREPARE_CURRENT_DATA:
            store.dispatch(customInternalData({
                matchId : getActiveMatchId(state),
                seasonId: getSeasonId(state),
                url: getStatisticCenterBaseUrl(state),
                lang: getLanguage(state),
            }));
            break;
    }
    return result;
}
const propagateCountdownByChannel = (store:any, countdown: number, channelId: number) : void => {
    const state = store.getState() as any as IState;
    const activeChannelId = getActiveChannelId(state);
    const activeMatchId = getActiveMatchId(state);
    const phaseId = getPhaseIdByMatchId(state,activeMatchId);
    const isBetstop = [PHASE_BETSTOP, PHASE_RALLY, PHASE_POST_MATCH].includes(phaseId);
    store.dispatch(sendCurrentPhaseData({
        eventId: activeMatchId,
        phase: !isBetstop ? 'place_bets' : 'betstop',
        countdown: countdown,
        channelId: channelId,
        activeChannelId: activeChannelId
    }));
}
function getIdOfMessage(messageData: any) {
    if(typeof(messageData) === 'string') {
      return parseUnifiedId(messageData);
    } else if(typeof(messageData) === 'number') {
      return messageData;
    } else {
      return messageData;
    }
}
function parseUnifiedId(unifiedMatchId: any) {
    return Number(unifiedMatchId.split(':')[2]);
}
export default customerIntegrationMiddleware;